import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import {
  SelectRoleWizardStepComponent,
} from '../../reports/dialogs/select-role-wizard-step/select-role-wizard-step.component';
import { IWizardStep } from '../wizard/wizard.component';
import {
  SelectUsersWizardStepComponent,
} from '../../reports/dialogs/select-users-wizard-step/select-users-wizard-step.component';
import { DialogComponent } from '../../shared/ui/dialog/dialog.component';

@Component({
  selector: 'app-filter-users-dialog',
  templateUrl: './filter-users-dialog.component.html',
  styleUrls: ['./filter-users-dialog.component.scss'],
})
export class FilterUsersDialogComponent implements OnInit {

  wizardSteps: IWizardStep[] = [];
  dialogRef: DialogComponent;

  currentUsersSelection: number[] = [];
  currentRole: string;

  constructor(
    private readonly store$: Store<IReducers>,
  ) {
  }

  ngOnInit(): void {
    this.wizardSteps = [
      {
        title: 'Select role',
        component: SelectRoleWizardStepComponent,
        id: SelectRoleWizardStepComponent.NAME,
        componentData: {
          currentRole: this.currentRole,
        },
      },
      {
        title: 'Select users',
        component: SelectUsersWizardStepComponent,
        id: SelectUsersWizardStepComponent.NAME,
        componentData: {
          preselectedUsers: this.currentUsersSelection,
        },
      },
    ];
  }

  onWizardFinish($event: any) {
    this.dialogRef.setResult($event);
    this.dialogRef.close();
  }
}
